module.exports = __webpack_public_path__ + "packs/media/images/Slider_4-8007e59ec905a115696b62ee08b415cb.jpg";